export default "__VITE_ASSET__BRnsn67p__"